var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.concepts),function(concept){return _c('TurningOn',{key:concept.id,attrs:{"name":concept.name,"time":_vm.getTime(concept)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }